import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="editor_comment-a"
            d="M6.11149365,10 L12,10 C12.5522847,10 13,9.55228475 13,9 L13,5 C13,4.44771525 12.5522847,4 12,4 L4,4 C3.44771525,4 3,4.44771525 3,5 L3,9 C3,9.55228475 3.44771525,10 4,10 L5,10 L5,11.2967426 L6.11149365,10 Z M6.57142857,11 L4,14 L4,11 C2.8954305,11 2,10.1045695 2,9 L2,5 C2,3.8954305 2.8954305,3 4,3 L12,3 C13.1045695,3 14,3.8954305 14,5 L14,9 C14,10.1045695 13.1045695,11 12,11 L6.57142857,11 Z"/>
    </defs>
    <g>
      <use xlinkHref="#editor_comment-a"/>
    </g>
  </svg>
);
